import { Helmet } from 'react-helmet';
import {Link, Route, Switch, useParams, useRouteMatch} from "react-router-dom";

export default function Projects() {
    let match = useRouteMatch();

    return (
        <div>
            <Helmet>
                <title>Projects | A. Page Code</title>
                <meta name="description" content="Basic example" />
            </Helmet>
            <h2>Projects</h2>
            <ul>
                <li>
                    <Link to={`${match.url}/true`}>True</Link>
                </li>
                <li>
                    <Link to={`${match.url}/ring`}>Ring</Link>
                </li>
            </ul>
            <Switch>
                <Route path={`${match.path}/:projectId`}>
                    <Project />
                </Route>
                <Route path={match.path}>
                    <h3>Please select a project.</h3>
                </Route>
            </Switch>
        </div>
    );
}

function Project() {
    let { projectId } = useParams<{ projectId: string }>();
    return <h3>Requested project ID: {projectId}</h3>;
}